<div class="ds-mobile-page-title">
    <h2 class="ds-mobile-page-title__title" [ngClass]="{'no-padding': noPadding}" [innerHTML]="title"></h2>
</div>
